import { render, staticRenderFns } from "./ClientPage.vue?vue&type=template&id=2323622a&scoped=true"
import script from "./ClientPage.vue?vue&type=script&lang=js"
export * from "./ClientPage.vue?vue&type=script&lang=js"
import style0 from "./ClientPage.vue?vue&type=style&index=0&id=2323622a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2323622a",
  null
  
)

export default component.exports